<app-navbar [imageHref]="CAP_HOME_URL"></app-navbar>

<div *ngIf="(isProcessing$ | async) !== false">
    <app-progress-indicator></app-progress-indicator>
</div>

<ng-container *ngIf="!checkLoadStatus((isLoading$ | async))">
    <!-- <ng-container> -->
    <div class="claim-cme-ce-container container">
        <div class="o-vr_x3">
            <a class="font-size-sm text-decoration-none" [href]="ELSS_HOME_URL">
                <!-- <fa-icon class="c-tooltip-icon m-0" [icon]="faArrowLeft"></fa-icon> -->
                <span class="icon"><i class="fa-solid fa-arrow-left" (click)="openContextualHelp()"></i></span>
                Back To e-LAB Solutions Suite Main Page
            </a>

        </div>
        <app-claim-cme-ce-confirmation-message
  *ngIf="(assignmentStatus$ | async) === ASSIGNMENT_STATUS_TYPES.SUCCESS"
  [kitNumber]="form.controls.kitNumber.value"
  [capNumber]="form.controls.capNumber.value"
 [lab]="selectedOrganization">
</app-claim-cme-ce-confirmation-message>



        <ng-container *ngIf="(assignmentStatus$ | async) !== ASSIGNMENT_STATUS_TYPES.SUCCESS">
            <h3 class="c-hdg c-hdg_4 o-vr o-vr_x2 d-inline">Claim CME/CE Credit for Faxed AP Results
                <span class="icon"><i class="fa-solid fa-square-question" (click)="openContextualHelp()"></i></span>
            </h3>
            <!-- <fa-icon
                (click)="openContextualHelp()"
                class="c-tooltip-icon font-size-md"
                [icon]="faQuesti
                onCircle"
            ></fa-icon> -->
            <p class="font-size-sm">
                <span>Claim CME/CE credit(s) for FNAG, NGC, PAP education program kits.</span>
            </p>
            <ul class="font-size-sm" style="margin-left: 20px;list-style-type:disc;">
                <li> Faxed result forms are processed within 2 business days. You may claim CME/CE credit after this
                    time.</li>
                <li> You may only claim credit for the kit in which you entered results.</li>
            </ul>
            <p class="font-size-sm">
                <span *ngIf="showAffiliatedText$ | async; else notAffiliatedText">
                    Select your laboratory/organization and enter your Kit #, click
                    <b>Assign Kit to My User ID</b> and confirm your laboratory/organization.
                    The Kit # will be associated with your name and credit will be awarded.
                </span>
                <ng-template #notAffiliatedText>
                    <span>Select your laboratory/organization and enter your Kit #, click
                        <b>Assign Kit to My User ID</b> and confirm your laboratory/organization.
                        The Kit # will be associated with your name and credit will be awarded.</span>
                </ng-template>
                <br />
               <span>If you have any questions, call a Customer Contact Center representative at 800-323-4040, Option 1 or +1-847-832-7000, Option 1 (for customers outside the US), or email <a href="mailto:contactcenter@cap.org" title="mailto:contactcenter@cap.org" data-renderer-mark="true" class="css-1rn59kg">contactcenter@cap.org.</a></span>
            </p>

            <app-claim-cme-ce-notification-box
                *ngIf="(assignmentStatus$ | async) === ASSIGNMENT_STATUS_TYPES.FAILURE"></app-claim-cme-ce-notification-box>

            <div class="col-md-7 no-gutter">
                <form class="form-container" [formGroup]="form">
                    <!-- CAP# Input: -->
                    <div class="form-group">
                        <p class="color-error font-size-sm">*Required</p>

                        <!-- Affiliated with Lab -->
                        <ng-container *ngIf="isAffiliated$ | async">
                            <label class="c-label required">
                                <span class="text">Laboratory/Organization:</span>
                            </label>
                            <select (change)="onOrganizationChange($event.target.value)" formControlName="organization"
                                [(ngModel)]="selectedOrganization" class="c-input">
                                <option *ngFor="let lab of laboratoryOrganizationOptions" [ngValue]="lab">
                                    <span>
                                        {{ getLabAffiliationLabel(lab) }}
                                    </span>
                                </option>
                                <option [value]="ENTER_CAP_AND_KIT_TEXT">{{ ENTER_CAP_AND_KIT_TEXT }}</option>
                            </select>
                        </ng-container>

                        <!-- No Lab Affiliation: -->
                        <ng-container
                            *ngIf="((isAffiliated$ | async) === false) || (selectedOrganization === ENTER_CAP_AND_KIT_TEXT)">


                            <label class="c-label required" style="margin-top: 15px;">
                                <span class="size">CAP #:</span>
                                <!-- <fa-icon
                                    class="c-info-icon font-size-md"
                                    [icon]="faInfoCircle"
                                    [tooltip]="CAPTooltip"
                                    tooltipPosition="above"
                                ></fa-icon> -->
                                <span class="icon"><i class="fa-solid fa-circle-info" [tooltip]="CAPTooltip"
                                        tooltipPosition="above"></i></span>
                            </label>
                            <input [ngClass]="['c-input', submitted && capNumberHasErrors ? 'field-error' : '']"
                                formControlName="capNumber" numbersOnly="true" maxlength="7" />
                            <div [ngClass]="['c-helper-text', submitted && capNumberHasErrors ? 'text-error' : '']">
                                Enter 7-digit CAP #
                            </div>
                        </ng-container>
                    </div>
                    <!-- Kit# Input: -->
                    <div class="form-group">
                        <label class="c-label required">
                            <span class="size">Kit #:</span>
                            <!-- <fa-icon
                                class="c-info-icon font-size-md"
                                [icon]="faInfoCircle"
                                [tooltip]="KitTooltip"
                                tooltipPosition="above"
                                zIndex="10"
                            ></fa-icon> -->
                            <span class="icon"><i class="fa-solid fa-circle-info" zIndex="10" [tooltip]="KitTooltip"
                                    tooltipPosition="above"></i></span>

                        </label>
                        <input [ngClass]="['c-input', submitted && kitNumberHasErrors ? 'field-error' : '']"
                            formControlName="kitNumber" numbersOnly="true" maxlength="8" />
                        <div [ngClass]="['c-helper-text', submitted && kitNumberHasErrors ? 'text-error' : '']">
                            Enter 8-digit Kit #
                        </div>
                    </div>

                    <button (click)="onSubmit()" class="c-btn-full" type="submit">Assign Kit to My User ID</button>
                </form>
            </div>
        </ng-container>
    </div>

    <!-- <app-error-modal *ngIf="showErrorModal$ | async" (closeModal)="closeErrorDialog()"></app-error-modal> -->
    <app-claim-cme-ce-help-modal *ngIf="showHelpModal$ | async" [contextualHelpHTML]="contextualHelpHTML$ | async"
        (closeModal)="closeHelpModal()"></app-claim-cme-ce-help-modal>

    <app-claim-cme-ce-confirmation *ngIf="showConfirmation$ | async" [name]="userFullName$ | async"
        [kitNumber]="form.controls.kitNumber.value" [capNumber]="form.controls.capNumber.value"
        [lab]="selectedOrganization === ENTER_CAP_AND_KIT_TEXT ? (derivedOrganization$ | async) : selectedOrganization"
        mailing="Mailing Code" (confirm)="assignKitToUser()" (closeConfirm)="closeConfirmation()">
    </app-claim-cme-ce-confirmation>

    <ng-template #KitTooltip>
        <span>Kit # is located on the result form in the upper right hand corner underneath the barcode.</span>
        <br />
        <span>If you do not know the Kit #, contact your administrator or <a appContactCap>contact the CAP.</a></span>
    </ng-template>

    <ng-template #CAPTooltip>
        <span>CAP # is located on the result form in the upper right hand corner underneath the barcode.</span>
        <br />
        <span>If you do not know your laboratory/organization CAP #, contact your administrator or
            <a appContactCap>contact the CAP.</a></span>
    </ng-template>
</ng-container>
<app-loading-indicator *ngIf="isLoading$ | async"></app-loading-indicator>
<app-footer></app-footer>
